<template>
    <div>
        <el-dialog
            title="Driver info"
            :visible.sync="show_dialogs.driver_profile"
            :close-on-click-modal="false"
            append-to-body
            top="5vh"
        >
            <div class="row form-group">
                <label class="col-sm-3 col-form-label">Name</label>
                <div class="col-sm-9">
                    <input type="text" class="form-control" v-model="form_data.name">
                </div>
            </div>
            <div class="row form-group">
                <div class="col-sm-3 col-form-label">Email</div>
                <div class="col-sm-9">
                    <input type="text" class="form-control" v-model="form_data.email">
                </div>
            </div>
            <div class="row form-group">
                <div class="col-sm-3 col-form-label">Phone</div>
                <div class="col-sm-9">
                    <input type="text" class="form-control" v-model="form_data.phone">
                </div>
            </div>

            <div class="row form-group">
                <div class="col-sm-3 col-form-label">Location</div>
                <div class="col-sm-9" style="display: flex; align-items: center;">
                    <input type="text" class="form-control" v-model="form_data.location" style="width: auto; flex-grow: 1">

                    <div class="col-form-label text-right" style="min-width: 125px; flex-grow: 0">
                        <div style="padding-right: 15px"><i style="padding: 0 15px">or</i> Zip Code</div>
                    </div>

                    <input type="text" class="form-control" v-model="form_data.zip_code" style="width: 100px; flex-grow: 0">
                </div>
            </div>

            <div class="row form-group pt-3">
                <div class="col-sm-3 col-form-label">CDL</div>
                <div class="col-sm-9" style="display: flex; align-items: center">
                    <label style="padding-right: 20px"><input type="checkbox" v-model="form_data.cdl.cdl_a"> Class A</label>
                    <label style="padding-right: 20px"><input type="checkbox" v-model="form_data.cdl.cdl_b"> Class B</label>
                    <label style="padding-right: 20px"><input type="checkbox" v-model="form_data.cdl.cdl_c"> Class C</label>
                </div>
            </div>
            <div class="row form-group">
                <label class="col-sm-3 col-form-label">CDL-A XP</label>
                <div class="col-sm-9">
                    <select class="form-control" v-model="form_data.cdl_xp" v-if="form_data.cdl.cdl_a || (! form_data.cdl.cdl_a && ! form_data.cdl.cdl_b && ! form_data.cdl.cdl_c)">
                        <option v-for="c in globals.cdl_xp" :value="c.id">{{ c.name }}</option>
                    </select>
                    <div v-else class="col-form-label">
                        I Need CDL Training
                    </div>
                </div>
            </div>

            <h5 style="margin: 45px 0 15px 0">Job preferences</h5>
            <driver-tags :data="form_data.categories"></driver-tags>

            <span slot="footer" class="dialog-footer">
                <el-button @click="show_dialogs.driver_profile = false">Close</el-button>
                <el-button @click="save" type="primary">Save profile</el-button>
            </span>

        </el-dialog>

        <btn icon="fas fa-pencil" cssClass="btn btn-secondary" :click="edit">Update</btn>
    </div>
</template>

<script>
import DriverTags from "./driver-tags";

export default {
        props: [
            'driver_id',
            'driver_info',
            'lists',
        ],
        components: {
            DriverTags,
        },
        data() {
            return {
                form_data: _.cloneDeep(this.driver_info),
                show_dialogs: {
                    driver_profile: false
                },
            };
        },
        watch: {
            driver_info() {
                this.form_data = _.cloneDeep(this.driver_info);
            }
        },
        methods: {
            edit() {
                this.show_dialogs.driver_profile = true;
            },
            save() {
                return axios.post(url(`admin/driver/${this.driver_id}/update`), this.form_data)
                .then(() => {
                    this.show_dialogs.driver_profile = false;

                    this.$emit('updated');
                });
            }
        }
    }
</script>

<style scoped>
    label {
        font-weight: normal
    }
</style>